// Default threshold values per spec (PRD 09 / FEAT-032 / BIO-001).
// Used by the 초기화 (reset) button — client-only, no API call.

import type { BiometricKey, BiometricRange } from '../types/biometric.types';

export const BIOMETRIC_DEFAULTS: Record<BiometricKey, BiometricRange> = {
  steps: { warnLow: 3000, normalMin: 5000, normalMax: 15000, warnHigh: 20000 },
  sleep: { warnLow: 4, normalMin: 6, normalMax: 9, warnHigh: 12 },
  heartRate: { warnLow: 50, normalMin: 60, normalMax: 100, warnHigh: 110 },
};

export const BIOMETRIC_META: Record<
  BiometricKey,
  { unit: string; step: number; absMin: number; absMax: number }
> = {
  steps: { unit: '걸음', step: 1, absMin: 1, absMax: 99999 },
  sleep: { unit: '시간', step: 0.1, absMin: 0.5, absMax: 24 },
  // 안정시 심박수: 정수(step 1), 절대범위 20~250 bpm (PRD 09 §4.2).
  heartRate: { unit: 'bpm', step: 1, absMin: 20, absMax: 250 },
};
